import styled from '@emotion/styled/macro';
import { getSportColour } from '../../sports/sportColours';

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
    height: 41px;
    display: flex;
    align-items: stretch;
    background: ${props => props.theme.colours.textWhite};
    border-radius: 8px;
    overflow: hidden;
`;

export const Label = styled.span`
    flex: 0 0 89px;
    display: flex;
    align-items: center;
    padding-left: 8px;
    box-sizing: border-box;
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.normal};
    color: ${props => props.theme.colours.textDark};
    white-space: nowrap;
`;

// Holder and name box are siblings (not overlapping) so the sport colour
// can't bleed past the rounded corners.
export const Selection = styled.div`
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    align-items: stretch;
    border-radius: 8px;
    overflow: hidden;
`;

export const Holder = styled.div`
    flex: 0 0 57px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 0 6px;
    box-sizing: border-box;
    background: #f3f4f4;
`;

export const NameBox = styled.div`
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    padding: 0 8px;
    background: ${props => getSportColour(props.sportType)};
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.normal};
    color: ${props => props.theme.colours.textWhite};
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const SelectionNumber = styled.span`
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.large};
    line-height: 1;
    color: ${props => props.theme.colours.textCardGreen};
`;

export const Icon = styled.span`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 23px;
    height: ${props => (props.sportType === 'football' ? '28px' : '17px')};

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;
